import { Box, Button, HStack, Text, type useToast } from '@chakra-ui/react';
import { Check } from 'lucide-react';

type Toast = ReturnType<typeof useToast>;

// "Saved to family Documents · View" (design: Confirmations & downloads): a
// dark pill with a saffron tick, and an optional way to go and see it.
export function savedToast(
  toast: Toast,
  title: string,
  options: {
    action?: { label: string; onClick: () => void };
    position?: 'top' | 'bottom';
  } = {}
) {
  toast({
    position: options.position ?? 'bottom',
    duration: 4000,
    render: ({ onClose }) => (
      <HStack
        role="status"
        spacing="10px"
        mb={options.position === 'top' ? 0 : '96px'}
        mx={4}
        py={2}
        pl="14px"
        pr={options.action ? 2 : 4}
        minH="44px"
        borderRadius="26px"
        bg="#1F1D1B"
        color="#FAF9F7"
        boxShadow="0 12px 24px -10px rgba(31, 29, 27, 0.5)"
      >
        <Box
          w="26px"
          h="26px"
          borderRadius="full"
          bg="saffron"
          color="#1F1D1B"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
          aria-hidden="true"
        >
          <Check size={16} strokeWidth={3} />
        </Box>
        <Text flex="1" fontSize="15px" fontWeight={600}>
          {title}
        </Text>
        {options.action && (
          <Button
            variant="ghost"
            colorScheme="gray"
            h="40px"
            px="14px"
            color="saffron"
            fontSize="15px"
            _hover={{ bg: 'whiteAlpha.200' }}
            onClick={() => {
              onClose();
              options.action?.onClick();
            }}
          >
            {options.action.label}
          </Button>
        )}
      </HStack>
    ),
  });
}
